export const formHeadingCss = {
    width: '50%',
    margin: 'auto',
    padding: '10px',
    color: 'white',
    fontSize: '130%',
    textAlign: 'center',
    backgroundColor: '#334d66'
};
